module.exports = __webpack_public_path__ + "static/img/folder.0943be12.svg";